export default "__VITE_ASSET__qr1KunGY__"